var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.QHloading)?_c('QHloading'):_vm._e(),_c('div',{staticClass:"QHpostionDaohang"},[_c('div',{staticClass:"box flex-center on"},[_c('span',[_vm._v(_vm._s(_vm.$getCityFuqin('name'))+"清运量热力图")])])]),_c('div',{staticClass:"QHzuobiaoMapPage",attrs:{"id":"map"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }